import { InertiaProps } from "@/types/app";
import { getImageUrl } from "@/utils/global";
import { usePage } from "@inertiajs/react";
import Marquee from "react-fast-marquee";

interface Props {
    props: string;
    bgLine: string;
}

const BannerNav: React.FC<Props> = ({ props, bgLine }) => {
    const { marquee } = usePage<InertiaProps>().props;
    return (
        <>
            <div
                style={{
                    backgroundImage: `url(${getImageUrl("/images/patrones/fondo%20test.png")})`,
                }}
                className={`banner-top bg-[url('/images/patrones/fondo%20test.png')] bg-[#790546] ${props}`}
            >
                <Marquee>
                    {marquee.map((elemento) => (
                        <div className="inline-flex" key={elemento.id}>
                            <div
                                className={`text-button-uppercase px-8 text-white`}
                            >
                                {elemento.texto}
                            </div>
                            <div className="flex justify-center items-center">
                                <div
                                    className={`bg-white w-[30px] h-[2px]`}
                                ></div>
                            </div>
                        </div>
                    ))}
                </Marquee>
            </div>
        </>
    );
};

export default BannerNav;
